import React from 'react'

export default React.createContext({
    name: '',
    setName: (name) => {},
    room: '',
    setRoom: (room) => {},
    rooms: [],
    setRooms: (rooms) => {},
    selectedUsername: '',
    setSelectedUsername: (username) => {},
    disconnectedUsername: '',
    setDisconnectedUsername: (username) => {},
    users: [],
    setUsers: (users) => {},
    message: '',
    setMessage: (message) => {},
    privateMessage: '',
    setPrivateMessage: (message) => {},
    deleteMessage: '',
    setDeleteMessage: (message) => {},
    uploadedFile: '',
    setUploadedFile: (file) => {},
    privateUploadedFile: '',
    setPrivateUploadedFile: (file) => {},
    messages: [],
    setMessages: (messages) => {},
    isSpeechActivated: false,
    setIsSpeechActivated: (isActivated) => {},
    isPrivateSpeech: false,
    setIsPrivateSpeech: (isActivated) => {},
    speechContent: '',
    setSpeechContent: (content) => {},
    privateSpeechContent: '',
    setPrivateSpeechContent: (content) => {},
    onSelectUsername: (e) => {},
    onSendMessage: (e) => {},
    onSendPrivateMessage: (e) => {},
    handleBlock: () => {},
    onUploadFile: () => {},
    onPrivateUploadFile: () => {},
    onSelectMessageToDelete: (message) => {},
    onDeleteMessage: () => {},
    logout: () => {},
})